/* tslint:disable */
import {
  Company,
  Group_employee,
  OrderEmployee,
  Gifts,
  Certificate,
  Employee_event,
  Event
} from '../index';

declare var Object: any;
export interface UserInterface {
  "name"?: string;
  "birthdate"?: Date;
  "maritalStatus"?: string;
  "anniversaryDate"?: any;
  "birthdateCouple"?: any;
  "parentType"?: string;
  "childrenBirthdates"?: Array<any>;
  "dateAdmission"?: Date;
  "payrollNumber"?: string;
  "image"?: string;
  "typeLogin"?: string;
  "balance"?: number;
  "companyId"?: number;
  "isAdmin"?: boolean;
  "adminId"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  "isDeleted"?: boolean;
  "registered"?: boolean;
  "country"?: string;
  "isSuperAdmin"?: boolean;
  "pass"?: string;
  "deletionRequest"?: boolean;
  "type"?: string;
  "system"?: boolean;
  "years"?: string;
  "video"?: boolean;
  "gender"?: boolean;
  "realm"?: string;
  "username"?: string;
  "email": string;
  "emailVerified"?: boolean;
  "id"?: number;
  "campusId"?: number;
  "password"?: string;
  accessTokens?: any[];
  company?: Company;
  groupEmployees?: Group_employee[];
  orderEmployees?: OrderEmployee[];
  gifts?: Gifts[];
  certs?: Certificate[];
  assistances?: Employee_event[];
  event?: Event[];
}

export class User implements UserInterface {
  "name": string;
  "birthdate": Date;
  "maritalStatus": string;
  "anniversaryDate": any;
  "birthdateCouple": any;
  "parentType": string;
  "childrenBirthdates": Array<any>;
  "dateAdmission": Date;
  "payrollNumber": string;
  "image": string;
  "typeLogin": string;
  "balance": number;
  "companyId": number;
  "isAdmin": boolean;
  "adminId": number;
  "createdAt": Date;
  "updatedAt": Date;
  "isDeleted": boolean;
  "registered": boolean;
  "country": string;
  "isSuperAdmin": boolean;
  "pass": string;
  "deletionRequest": boolean;
  "type": string;
  "system": boolean;
  "years": string;
  "video": boolean;
  "gender": boolean;
  "realm": string;
  "username": string;
  "email": string;
  "emailVerified": boolean;
  "id": number;
  "campusId": number;
  "password": string;
  accessTokens: any[];
  company: Company;
  groupEmployees: Group_employee[];
  orderEmployees: OrderEmployee[];
  gifts: Gifts[];
  certs: Certificate[];
  assistances: Employee_event[];
  event: Event[];
  constructor(data?: UserInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `User`.
   */
  public static getModelName() {
    return "User";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of User for dynamic purposes.
  **/
  public static factory(data: UserInterface): User{
    return new User(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'User',
      plural: 'Users',
      path: 'Users',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "birthdate": {
          name: 'birthdate',
          type: 'Date'
        },
        "maritalStatus": {
          name: 'maritalStatus',
          type: 'string'
        },
        "anniversaryDate": {
          name: 'anniversaryDate',
          type: 'any'
        },
        "birthdateCouple": {
          name: 'birthdateCouple',
          type: 'any'
        },
        "parentType": {
          name: 'parentType',
          type: 'string'
        },
        "childrenBirthdates": {
          name: 'childrenBirthdates',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "dateAdmission": {
          name: 'dateAdmission',
          type: 'Date'
        },
        "payrollNumber": {
          name: 'payrollNumber',
          type: 'string'
        },
        "image": {
          name: 'image',
          type: 'string'
        },
        "typeLogin": {
          name: 'typeLogin',
          type: 'string'
        },
        "balance": {
          name: 'balance',
          type: 'number',
          default: 0
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "isAdmin": {
          name: 'isAdmin',
          type: 'boolean'
        },
        "adminId": {
          name: 'adminId',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date',
          default: new Date(0)
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date',
          default: new Date(0)
        },
        "isDeleted": {
          name: 'isDeleted',
          type: 'boolean',
          default: false
        },
        "registered": {
          name: 'registered',
          type: 'boolean',
          default: false
        },
        "country": {
          name: 'country',
          type: 'string'
        },
        "isSuperAdmin": {
          name: 'isSuperAdmin',
          type: 'boolean',
          default: false
        },
        "pass": {
          name: 'pass',
          type: 'string'
        },
        "deletionRequest": {
          name: 'deletionRequest',
          type: 'boolean',
          default: false
        },
        "type": {
          name: 'type',
          type: 'string'
        },
        "system": {
          name: 'system',
          type: 'boolean'
        },
        "years": {
          name: 'years',
          type: 'string'
        },
        "video": {
          name: 'video',
          type: 'boolean',
          default: false
        },
        "gender": {
          name: 'gender',
          type: 'boolean'
        },
        "realm": {
          name: 'realm',
          type: 'string'
        },
        "username": {
          name: 'username',
          type: 'string'
        },
        "email": {
          name: 'email',
          type: 'string'
        },
        "emailVerified": {
          name: 'emailVerified',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "campusId": {
          name: 'campusId',
          type: 'number'
        },
        "password": {
          name: 'password',
          type: 'string'
        },
      },
      relations: {
        accessTokens: {
          name: 'accessTokens',
          type: 'any[]',
          model: '',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'userId'
        },
        company: {
          name: 'company',
          type: 'Company',
          model: 'Company',
          relationType: 'belongsTo',
                  keyFrom: 'companyId',
          keyTo: 'id'
        },
        groupEmployees: {
          name: 'groupEmployees',
          type: 'Group_employee[]',
          model: 'Group_employee',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'userId'
        },
        orderEmployees: {
          name: 'orderEmployees',
          type: 'OrderEmployee[]',
          model: 'OrderEmployee',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'userId'
        },
        gifts: {
          name: 'gifts',
          type: 'Gifts[]',
          model: 'Gifts',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'userId'
        },
        certs: {
          name: 'certs',
          type: 'Certificate[]',
          model: 'Certificate',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'userId'
        },
        assistances: {
          name: 'assistances',
          type: 'Employee_event[]',
          model: 'Employee_event',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'userId'
        },
        event: {
          name: 'event',
          type: 'Event[]',
          model: 'Event',
          relationType: 'hasMany',
          modelThrough: 'Employee_event',
          keyThrough: 'eventId',
          keyFrom: 'id',
          keyTo: 'userId'
        },
      }
    }
  }
}
